import { apiFetch } from '@/lib/api-client';
import type { ForcedBlacklistFeedbackPreview, ForcedBlacklistFeedbackResult } from '@uniticket/shared';

// « Forcer » une ligne dans le fichier de retour blacklist, depuis la console DMP (admins seuls, 17-09).

/** La ligne exacte qui serait écrite, et ce qui a déjà été forcé pour ce JVID. N'écrit rien. */
export async function fetchForcedFeedbackPreview(jvid: number) {
  return apiFetch<{ data: ForcedBlacklistFeedbackPreview }>(`/dmp/console/blacklist-feedback/force-preview?jvid=${jvid}`);
}

export async function forceBlacklistFeedback(jvid: number, comment: string) {
  return apiFetch<{ data: ForcedBlacklistFeedbackResult }>('/dmp/console/blacklist-feedback/force', {
    method: 'POST',
    body: JSON.stringify({ jvid, comment }),
  });
}
